const DAILY_ROOM_BASE_URL = 'https://plumaa.daily.co';

export function buildDailyPublicRoomUrl(providerId: string): string {
	const roomId = providerId.trim();
	return `${DAILY_ROOM_BASE_URL}/${encodeURIComponent(roomId)}`;
}
